import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-row-action',
  templateUrl: './row-action.component.html',
  styleUrls: ['./row-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RowActionComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  onCopy(): void {}
  openDelete(): void {}
}
